import { OverviewPage } from './OverviewPage'
import { getOverviewPath } from './paths'

export const routes = [
  {
    path: getOverviewPath(),
    component: OverviewPage,
    exact: true
  }
]
